import React from "react";
import "./App.css";
import Home from "./pages";
import Meetup from "./pages/meetup";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import PrivacyPolicyPage from "./pages/privacy";
import TermsPage from "./pages/terms";
import BookingPage from "./pages/booking";
import ContactPage from "./pages/contact";
import SmsTermsPage from "./pages/sms-terms";

function App() {
  return (
    <Router>
      <Switch>
        <Route path="/" component={Home} exact />
        <Route path="/meetup" component={Meetup} />
        <Route path="/privacy" component={PrivacyPolicyPage} />
        <Route path="/terms" component={TermsPage} />
        <Route path="/booking" component={BookingPage} />
        <Route path="/contact" component={ContactPage} />
        <Route path="/sms-terms" component={SmsTermsPage} />
      </Switch>
    </Router>
  );
}

export default App;
